import { Progress, Spin } from 'antd'
import dayjs from 'dayjs'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { ReactComponent as CalendarIcon } from '../../../assets/icons/calendar.svg'
import { RootState } from '../../../redux'
import { ICurrentUserLoadDetailPayload } from '../../../redux/currentUser/currentUserActions'
import { WITHDRAWAL_STATE } from '../../../utils/enums'
import { formatAsCurrency } from '../../../utils/helpers'

type IWithdrawalsDashboardOverview = {}

const WithdrawalsDashboardOverview: FC<IWithdrawalsDashboardOverview> = () => {
	const { t } = useTranslation()

	const currentUser: ICurrentUserLoadDetailPayload = useSelector((state: RootState) => state.currentUser.detail)

	const today = dayjs().startOf('day')
	const periodStartDate = dayjs(currentUser.record?.periodStartDate).startOf('day')
	const periodEndDate = dayjs(currentUser.record?.periodEndDate).startOf('day')
	const nextPayDate = dayjs(currentUser.record?.nextPayDate).startOf('day')

	const daysInCurrentPeriod = periodEndDate.diff(periodStartDate, 'days')
	const daysBetweenTodayAndPeriodStartDate = today.diff(periodStartDate, 'days')
	const percentageProgressOfCurrentPeriod = Number(((daysBetweenTodayAndPeriodStartDate / daysInCurrentPeriod) * 100).toFixed(2))
	const daysBetweenTodayAndNextPayDate = today.diff(nextPayDate, 'days')

	const calculateAvailableEarnings = () => {
		if (currentUser.record?.withdrawalAmount && currentUser.record?.withdrawalState === WITHDRAWAL_STATE.PENDING) {
			return (currentUser.record?.availableEarnings || 0) - currentUser.record.withdrawalAmount
		}
		return currentUser.record?.availableEarnings || 0
	}

	return currentUser.isLoading ? (
		<div className={'h-80 flex justify-center items-center'}>
			<Spin size={'large'} />
		</div>
	) : (
		<>
			{/* radsej to tu necham keby nahodou */}

			{/* {isMobile && currentUser.record?.withdrawalID && currentUser.record?.withdrawalState === WITHDRAWAL_STATE.PENDING && ( */}
			{/*	<div className={'flex justify-between items-center text-14 font-400 bg-white p-4 rounded-md shadow-lg mb-6'}> */}
			{/*		<span> {`${t('loc:employee|Withdrawal Request')} ${formatAsCurrency(currentUser.record.withdrawalAmount)}`}</span> */}
			{/*		<StateItem state={currentUser.record.withdrawalState} /> */}
			{/*	</div> */}
			{/* )} */}

			<div className={'flex flex-col items-center bg-purple-light py-6 px-6 xxl:px-16 rounded-md shadow-md mb-6 lg:mb-10'}>
				{currentUser.record?.periodStartDate && currentUser.record?.periodEndDate && (
					<span className={'text-12 font-400 text-gray-500 mb-3'}>{`${dayjs(currentUser.record.periodStartDate).format('D MMMM')} - ${dayjs(
						currentUser.record.periodEndDate
					).format('D MMMM')}`}</span>
				)}

				<span className={'text-17 font-400 mb-2'}>{t('loc:employee|Your available Earnings')}</span>
				<h2 className={'text-40 font-600 leading-none'}>
					{formatAsCurrency(calculateAvailableEarnings(), currentUser.record?.company?.countryCode) as string}
				</h2>

				{currentUser.record?.withdrawalAmount && currentUser.record?.withdrawalState === WITHDRAWAL_STATE.PENDING && (
					<h3
						className={
							'inline-flex items-center whitespace-nowrap text-16 font-600 mt-3 before:w-2 before:h-2 before:bg-warning before:rounded-full before:mr-3 before:flex-shrink-0'
						}
					>{`${formatAsCurrency(currentUser.record.withdrawalAmount, currentUser.record?.company?.countryCode)} ${t('loc:employee|pending')}`}</h3>
				)}

				{currentUser.record?.periodStartDate && currentUser.record?.periodEndDate && currentUser.record?.nextPayDate && (
					<>
						<Progress type={'line'} strokeWidth={14} showInfo={false} percent={percentageProgressOfCurrentPeriod} className={'my-3'} />

						<div className={'w-100% flex justify-between items-center text-13 font-400 text-gray-500'}>
							<div className={'inline-flex items-center gap-2'}>
								<CalendarIcon className={'text-18'} />
								<div className={'flex flex-col sm:flex-row sm:items-center sm:gap-1'}>
									<span className={'text-gray-500'}>
										{daysBetweenTodayAndNextPayDate > 0 ? t('loc:employee|Last payday') : t('loc:employee|Last withdrawal date in current period')}:
									</span>
									<span className={'font-500 text-gray-700'}>{dayjs(currentUser.record.nextPayDate).format('D MMMM')}</span>
								</div>
							</div>
							{daysBetweenTodayAndNextPayDate > 0 ? (
								<span>
									{Math.abs(daysBetweenTodayAndNextPayDate) === 1
										? t('loc:employee|{{days}} day ago', { days: Math.abs(daysBetweenTodayAndNextPayDate) })
										: t('loc:employee|{{days}} days ago', { days: Math.abs(daysBetweenTodayAndNextPayDate) })}
								</span>
							) : (
								<span>
									{Math.abs(daysBetweenTodayAndNextPayDate) === 1 && t('loc:employee|{{days}} day left', { days: Math.abs(daysBetweenTodayAndNextPayDate) })}
									{[2, 3, 4].includes(Math.abs(daysBetweenTodayAndNextPayDate)) &&
										t('loc:employee|{{days}} days left', { days: Math.abs(daysBetweenTodayAndNextPayDate) })}
									{Math.abs(daysBetweenTodayAndNextPayDate) >= 5 && t('loc:employee|{{days}} dayss left', { days: Math.abs(daysBetweenTodayAndNextPayDate) })}
								</span>
							)}
						</div>
					</>
				)}
			</div>
		</>
	)
}

export default WithdrawalsDashboardOverview
